import { authAlova } from "../lib/alova";
import { setToken, setRefreshToken } from "../lib/auth";
import { apiAlova } from "../lib/alova";
import type { LoginResponse } from "../types/auth";
import type { ApiResponse } from "../types/api";

export async function login(username: string, password: string) {
  const res = await authAlova
    .Post<ApiResponse<LoginResponse>>("/auth/login", { username, password, type: 'web' })
    .send();

  if ("error" in res) {
    throw new Error(res.message || "Login gagal");
  }

  // ✅ kalau success
  const loginData = res.data;
  if (loginData) {
    setToken(loginData.tokens.access_token);
    setRefreshToken(loginData.tokens.refresh_token);
  }

  return { loginData, message: res.message };
}

export async function getProfile(force = false) {
  const res = await apiAlova
    .Get<ApiResponse<any>>(`/auth/profile?${force ? `ts=${Date.now()}` : ""}`)
    .send();

  if ("error" in res) {
    throw new Error(res.message || "Gagal ambil profile");
  }

  return res.data;
}
